<template>
  <div v-if="data" class="report-view">
    <InterlayerPage
      :disable-count="pageCount"
      :site="site.name"
      section="outlier"
      :baseline="site.name"
      :filters="filters"
      class="page"
      :title="$t('sections.outlier')"
      :transports="[transportMode]"
      :comment="comment"
      :study-collaborators-count="data.collaboratorsCount"
      :transport-collaborators-count="data.filteredCollaboratorsCount"
    />
    <AnalysisSection v-for="(enumeration, idx) in enumerable()" :key="idx" :page-count="pageCount + idx + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.outlier') }}</h2>
        <h5>
          {{ $t('report.outlierFocus') }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
      </template>
      <template #body>
        <Focus :data="data" :range="enumeration" :forcedTransport="data.transportMode.key" />
      </template>
    </AnalysisSection>
  </div>
</template>

<script>
import AnalysisMixin from '@/components/Export/Analysis/Mixin';
import Focus from '@/components/Analysis/Outlier/Focus';

export default {
  components: {
    Focus,
  },

  mixins: [AnalysisMixin],
};
</script>
